import React from 'react';
import { SelectDescriptor } from '@progress/kendo-react-data-tools';
import { GridHeaderSelectionChangeEvent, GridSelectionChangeEvent } from '@progress/kendo-react-grid';
import CardGrid from '@components-clean/core/grid/card-grid';
import { GridCheckboxSelectionDummyColumns, GridDummyData } from '@pages-clean/dummy-page/dummy-page.data';

const CheckboxSelectionGridPage = () => {
    const DATA_ITEM_KEY: string = 'ProductID';
    const [select, setSelect] = React.useState<SelectDescriptor>({});

    const onSelectionChange = React.useCallback((event: GridSelectionChangeEvent) => {
        setSelect(event.select);
    }, []);

    const onHeaderSelectionChange = React.useCallback((event: GridHeaderSelectionChangeEvent) => {
        setSelect(event.select);
    }, []);

    return (
        <CardGrid
            title="Core Checkbox Selection Grid"
            maxHeight="auto"
            testDataId="checkbox-selection-dummy-grid"
            dataItemKey={DATA_ITEM_KEY}
            autoProcessData
            data={GridDummyData}
            columns={GridCheckboxSelectionDummyColumns}
            canEdit
            filterable={false}
            selectable={{
                enabled: true,
                drag: false,
                cell: false,
                mode: 'multiple',
            }}
            select={select}
            onHeaderSelectionChange={onHeaderSelectionChange}
            onSelectionChange={onSelectionChange}
        />
    );
};

export default CheckboxSelectionGridPage;
